/** Font properties that decide how wide a run of text renders. */
export interface TextMeasureStyle {
  /** CSS `font` shorthand. Set either this or the individual properties below. */
  font?: string;
  fontFamily?: string;
  fontSize?: string;
  fontWeight?: number | string;
  letterSpacing?: string;
  fontVariantNumeric?: string;
}

/**
 * Rendered width of `text` in px, measured with an off-screen probe so it
 * matches the browser's own layout, including letter spacing and tabular figures.
 */
export function measureTextWidth(text: string, style: Readonly<TextMeasureStyle>): number {
  const probe = document.createElement("span");
  probe.textContent = text;
  probe.style.position = "absolute";
  probe.style.left = "-9999px";
  probe.style.whiteSpace = "pre";
  if (style.font) probe.style.font = style.font;
  if (style.fontFamily) probe.style.fontFamily = style.fontFamily;
  if (style.fontSize) probe.style.fontSize = style.fontSize;
  if (style.fontWeight != null) probe.style.fontWeight = String(style.fontWeight);
  probe.style.letterSpacing = style.letterSpacing ?? "normal";
  if (style.fontVariantNumeric) probe.style.fontVariantNumeric = style.fontVariantNumeric;
  document.body.appendChild(probe);
  const width = probe.getBoundingClientRect().width;
  probe.remove();
  return width;
}
